export default __webpack_public_path__ + "static/media/pit.b54d5fcf.png";